module.exports = __webpack_public_path__ + "img/battante.d159974.svg";